import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter as Router, Switch, Route, Redirect} from 'react-router-dom';
import { ThemeProvider, createTheme, responsiveFontSizes } from '@mui/material';
import { Provider } from 'react-redux';
import store from './storeredux'
import Main from './Component/main/Main';

// const analytics = getAnalytics();
// logEvent(analytics, 'notification_received');

const theme1 = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
})

const theme = responsiveFontSizes(theme1)

ReactDOM.render(
  <Router>
    <Switch>
      <Route exact path='/'>
        <Provider store={store}>
          <ThemeProvider theme={theme}><Main/></ThemeProvider>
        </Provider>
      </Route>
      <Route exact path='/mpq-ums'>
        <Redirect to="/"/>
      </Route>
    </Switch>
  </Router>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// <Route path='/developer-info' component={InfoDeveloper} />
// <Route component={PageNotFound} />
